<div class="loading text-center mt-5" *ngIf="loading">
	<div class="spinner-border text-warning" role="status">
		<span class="visually-hidden">Loading...</span>
	</div>
</div>
